<template>
    <div class="map-container" @click.prevent.stop>
        <google-map
            id="map"
            ref="Map"
            :center="center | convertLatLng"
            :zoom="zoomLevel"
            :options="{
                fullscreenControl: false,
                scaleControl: false,
                mapTypeControl: false,
                mapId: '1b3152c12e59d9d1',
                minZoom: 2,
            }"
            @click="moveMarker"
        >
            <google-map-infowindow
                :position="popupInfo.position"
                :show.sync="showPopup"
                :options="{ maxWidth: 300 }"
                @info-window-clicked="showPopup = false"
            >
                <p class="notification title is-6">
                    {{ popupInfo.message }}
                </p>
            </google-map-infowindow>
            <!--google-map-marker
        v-if="location"
        :position="location | convertLatLng"
        :draggable="true"
        @dragend="moveMarker"
      /-->
        </google-map>
    </div>
</template>

<script>
import { getDistance } from 'geolib';
import { isNaN } from 'underscore';
import MapboxToGoogleMaps from '@/mixins/MapboxToGoogleMaps';
export default {
    mixins: [MapboxToGoogleMaps],
    model: {
        prop: 'location',
    },
    props: {
        location: {
            type: Object,
            default() {
                return {};
            },
        },
        targetLocation: {
            type: Object,
            default() {
                return {};
            },
        },
        bounds: {
            type: Object,
            default() {
                return {};
            },
        },
        center: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            position: {},
            zoomLevel: 16,
            popupInfo: {
                title: 'a title',
                description: 'a description',
                position: {
                    lat: 44.2899,
                    lng: 11.8774,
                },
            },
            showPopup: false,
        };
    },
    computed: {
        distance() {
            return getDistance(this.location, this.targetLocation, 10);
        },
    },
    watch: {
        distance: 'setPopup',
    },
    methods: {
        moveMarker({ latLng }) {
            this.setPosition(latLng.lng(), latLng.lat());
        },
        setPosition(lon, lat) {
            this.$set(this.position, 'latitude', lat);
            this.$set(this.position, 'longitude', lon);
            //this.$refs.Map.flyTo({ center: [lon, lat], zoom: this.zoomLevel });
            this.$emit('input', this.position);
        },
        setPopup() {
            if (isNaN(this.distance)) {
                return console.log('not showing popup NaN');
            }
            this.popupInfo = {
                position: {
                    lat: this.position.latitude,
                    lng: this.position.longitude,
                },
                message: this.$t('Sessions.messages.distance_to_target', {
                    distance: this.distance,
                }),
            };
            this.showPopup = true;
            setTimeout(() => {
                this.showPopup = false;
            }, 2000);
        },
    },
};
</script>

<style scoped>
@import '~vuejs-google-maps/dist/vuejs-google-maps.css';
.map-container {
    height: 20rem !important;
}
</style>
